<script setup lang="ts">
import { ButtonPrimaryAccented, ButtonTertiaryOutlined } from '~/features/ui-kit';
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import SvgIcon18plus from './SvgIcon18plus.vue';
import { useUserStore } from '~/features/store';

const emits = defineEmits<{ (event: 'close'): void }>();

const { confirmAdult } = useUserStore();

function confirm() {
  confirmAdult(true);
  emits('close');
}

function reject() {
  confirmAdult(false);
  emits('close');
}
</script>

<template>
  <MMPopupDefault :is-closable="false" class="popup-adult-confirm" @close="$emit('close')">
    <template #default>
      <div class="popup-adult-confirm__body">
        <SvgIcon18plus height="48" width="48" />

        <div class="popup-adult-confirm__body__info">
          <MMText font="Title S/Semibold">Вам уже есть 18 лет?</MMText>
          <MMText font="Body M/Regular" color="tertiary">
            Вы переходите на товар «для взрослых»
          </MMText>
        </div>

        <div class="popup-adult-confirm__body__buttons">
          <ButtonTertiaryOutlined @click="reject" w100>Нет</ButtonTertiaryOutlined>
          <ButtonPrimaryAccented @click="confirm" w100>Да, мне есть 18</ButtonPrimaryAccented>
        </div>
      </div>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.popup-adult-confirm
  width 540px

  &__body
    display flex
    flex-direction column
    align-items center
    gap 32px
    padding 32px 0

    &__info
      display flex
      flex-direction column
      align-items center
      gap 12px

    &__buttons
      display flex
      gap 12px
      width 70%
      +Media(Mobile, Tablet)
        width 100%
</style>
